// Mock jobs data
const jobs = [
  {
    id: 1,
    title: 'Junior Software Engineer',
    company: '',
    location: 'Mangalore',
    industry: 'IT',
    type: 'Full Time',
    description: 'Develop and maintain web applications. React/Node.js, Mysql/PostgreSQL experience preferred.',
    contactperson: '',
    contactemail: 'jobs@mangalorehub.com',
    contactnumber: '',
    datePosted: '2026-02-20',
    dateofexpiry: '2026-03-15',
    listorder: 1,
    accountstatus: 'A'
  },
  {
    id: 4,
    title: 'Home Nurse',
    company: '',
    location: 'Mangalore',
    industry: 'Healthcare',
    type: 'Full Time',
    description: 'Patient care.',
    contactperson: '',
    contactemail: 'jobs@mangalorehub.com',
    contactnumber: '',
    datePosted: '2025-09-10',
    dateofexpiry: '2025-10-10',
    listorder: 4,
    accountstatus: 'A'  
  },
  {
    id: 6,
    title: 'Junior Marketing Executive',
    company: '',
    location: 'Mangalore',
    industry: 'IT',
    type: 'Full Time',
    description: 'Call customers, manage targets, customer relations. Experience in retail marketing is a plus. Freshers can also apply.',
    contactperson: '',
    contactemail: 'jobs@mangalorehub.com',
    contactnumber: '',
    datePosted: '2026-02-10',
    dateofexpiry: '2026-03-15',
    listorder: 6,
    accountstatus: 'A'
  },
  {
    id: 8,
    title: 'Graphic Designer',
    company: '',
    location: 'Mangalore',
    industry: 'Design',
    type: 'Part Time',
    description: 'Create graphics, banners, and social media posts.',
    contactperson: '',
    contactemail: 'jobs@mangalorehub.com',
    contactnumber: '',
    datePosted: '2025-09-01',
    dateofexpiry: '2025-10-01',
    listorder: 8,
    accountstatus: 'A'
  },
  {
    id: 12,
    title: 'Content Writer',
    company: '',
    location: 'Mangalore',
    industry: 'Media',
    type: 'Part Time',
    description: 'Write articles, blogs, and website content.',
    contactperson: '',
    contactemail: 'jobs@mangalorehub.com',
    contactnumber: '',
    datePosted: '2025-08-22',
    dateofexpiry: '2025-09-22',
    listorder: 12,
    accountstatus: 'A'
  },
];

export default jobs;
